import { render } from "./MenuSocialMedia.vue?vue&type=template&id=646508a2&scoped=true"
import script from "./MenuSocialMedia.vue?vue&type=script&lang=js"
export * from "./MenuSocialMedia.vue?vue&type=script&lang=js"

import "./MenuSocialMedia.vue?vue&type=style&index=0&id=646508a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646508a2"]])

export default __exports__